export default __webpack_public_path__ + "static/media/Bolts of the Haunter in the Dark.093a37cd.jpg";